// 终端用户用的接口
import request from "@/utils/request";

// 游客-订单列表查询接口
export function queryNormalOrderList(params) {
  return request({
    url: "/order/noToken/queryNormalOrderList",
    method: "post",
    params: params,
    metaValue: "游客订单列表"
  });
}

// 游客-订单详情接口
export function getNormalOrderListDetail(params) {
  return request({
    url: "/order/noToken/getNormalOrderListDetails",
    method: "post",
    params: params,
    metaValue: "游客订单详情"
  });
}

// 带token-其他产品订单详情接口
export function getOtherOrderListDetail(params) {
  return request({
    url: "/order/authToken/getOrderListDetails",
    method: "post",
    params: params,
    metaValue: "其他产品订单详情"
  });
}

// 400号码订购接口
export function getFourHundredInfo(params) {
  return request({
    url: "/order/noToken/getFourHundredInfo",
    method: "post",
    params: params,
    metaValue: "400号码订购"
  });
}

// 修改400订单信息
export function editFourHundredInfo(params) {
  return request({
    url: "/order/noToken/editFourHundredInfo",
    method: "post",
    params: params,
    metaValue: "修改400订单"
  });
}

// 游客-号码认证信息查询接口
export function hmrzQuest(params) {
  return request({
    url: "/order/noToken/getNumberAuthInfo",
    method: "post",
    params: params,
    metaValue: "号码认证信息查询"
  });
}

// 游客-号码认证提交欣能汇
export function postXnhcircleAdd(params) {
  return request({
    url: "/xnh/authToken/postXnhcircleAdd",
    method: "post",
    params: params,
    metaValue: "号码认证提交欣能汇"
  });
}

// 游客-上报欣能汇号码认证二次添加
export function postXnhAddNumber(params) {
  return request({
    url: "/xnh/authToken/postXnhAddNumber",
    method: "post",
    params: params,
    metaValue: "号码认证修改"
  });
}

// 游客-号码认证修改
export function editNumberAuthInfo(params) {
  return request({
    url: "/order/noToken/editNumberAuthInfo",
    method: "post",
    params: params,
    metaValue: "号码认证修改"
  });
}

// 游客-模糊查询号码认证成员号码接口
export function queryOrderNumberAuthMobile(params) {
  return request({
    url: "/order/noToken/queryOrderNumberAuthMobile",
    method: "post",
    params: params,
    metaValue: "模糊查询号码认证成员号码接口"
  });
}

// 游客-模糊查询彩铃统付成员接口
export function queryNormalOrderMobile(params) {
  return request({
    url: "/order/noToken/queryNormalOrderMobile",
    method: "post",
    params: params,
    metaValue: "模糊查询彩铃统付成员接口"
  });
}



// WEBPACK FOOTER //
// ./src/api/api/customer.js